import { TFunction } from "i18next";
import { ExportDifferentialBonusRequest } from "../../../../../types/DifferentialBonusExport";
import defaultContent from "../../../../../content/monthlyPerformanceTotalModals";
import commonContent from "../../../../../content/common";
import leafAboNameContent from "../../../../../content/leafAboName";

/**
 * Prepares the content payload for the differential bonus PDF export API
 * Gathers all translated labels from i18n and includes the Amway logo as base64
 *
 * @param t - Translation function from useTranslation hook
 * @returns Complete request payload for the export API
 */
/**
 * Extracts the label part from a template string by removing template variables
 * Example: "{aboBonusPercent} Performance Bonus" -> "Performance Bonus"
 */
const extractLabel = (templateString: string): string => {
  // Remove {variable} patterns and trim
  return templateString.replace(/\{[^}]+\}\s*/g, "").trim();
};

export const prepareDifferentialBonusContent = (t: TFunction): ExportDifferentialBonusRequest => {
  // Get translated template strings
  const aboBonusPercentTemplate = t(
    "monthlyPerformanceTotalModals:differential.table.aboBonusPercent",
    defaultContent.differential.table.aboBonusPercent,
  ) as string;
  const aboGpvTemplate = t(
    "monthlyPerformanceTotalModals:differential.table.aboGpv",
    defaultContent.differential.table.aboGpv,
  ) as string;

  return {
    differential: {
      title: t("monthlyPerformanceTotalModals:differential.title", defaultContent.differential.title) as string,
      subTitle: t(
        "monthlyPerformanceTotalModals:differential.subTitle",
        defaultContent.differential.subTitle,
      ) as string,
      table: {
        groupBV: t(
          "monthlyPerformanceTotalModals:differential.table.personalBV",
          defaultContent.differential.table.personalBV,
        ) as string,
        differentialMultiplier: t(
          "monthlyPerformanceTotalModals:differential.table.bonusPercent",
          defaultContent.differential.table.bonusPercent,
        ) as string,
        personalBonusAmount: t(
          "monthlyPerformanceTotalModals:differential.table.personalBonusAmount",
          defaultContent.differential.table.personalBonusAmount,
        ) as string,
        nonBonusable: t(
          "monthlyPerformanceTotalModals:differential.table.nonBonusable",
          defaultContent.differential.table.nonBonusable,
        ) as string,
        total: t(
          "monthlyPerformanceTotalModals:differential.table.total",
          defaultContent.differential.table.total,
        ) as string,
        performanceBonus: extractLabel(aboBonusPercentTemplate),
        gpv: extractLabel(aboGpvTemplate),
      },
    },
    bonusesDisclaimer: t("common:bonusesDisclaimer", commonContent.bonusesDisclaimer) as string,
    totalsDisclaimer: t("common:totalsDisclaimer", commonContent.totalsDisclaimer) as string,
    footer: t("common:footer", commonContent.footer) as string,
    confidentialUser: t("leafAboName:ConfidentialUser", leafAboNameContent.ConfidentialUser) as string,
    notAvailable: t("leafAboName:notAvailable", leafAboNameContent.notAvailable) as string,
  };
};
